<template>
    <div class="card-base card-shadow--medium mb-30">
        <div v-if="$slots.header" class="p-20 flex justify-space-between">
            <div>
                <h2 class="mv-0">
                    <slot name="header" />
                </h2>
            </div>
        </div>
        <div class="pl-20 pr-20 pb-20" :class="{ 'pt-20': !$slots.header }">
            <slot name="body" />
            <slot />
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
